import CatalogPage from "./CatalogPage";
import RoomPage from "./RoomPage";
import { Brand, Category, Product } from "../types";
import { categoryPathMap, roomMap } from "../content/ecommerceContent";
import { useParams } from "react-router-dom";

export default function EcommerceSlugPage({ categories, brands, products }: { categories: Category[]; brands: Brand[]; products: Product[] }) {
  const { slug = "" } = useParams();
  if (categoryPathMap[slug]) return <CatalogPage categories={categories} brands={brands} products={products} routeCategory={categoryPathMap[slug]} routeHeadingSlug={slug} />;
  if (roomMap[slug]) return <RoomPage />;
  return <CatalogPage categories={categories} brands={brands} products={products} />;
}